let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i6I9Z")).then(() => parcelRequire('j06kL'));